export enum Colors {
  Black = "#121316",
  Midgrey = "#a8a8a8",
  TangerineOrange = "#fea801",
  CrimsonRed = "#9E0707",
  BurgundyRed = "#7C0303",
  Grey = "#9ea8b5",
  DarkGrey = "#646464",
  White = "#FFFFFF",
  VeryLightGrey = "#F7F7F7",
  LightGrey = "#D9D5D5",
  LightAshRose = "#ECE8E8",
  DarkOffWhite = "#e0e0e0",
  AshRose = "#b76e79",
  Tomato = "#ff0000",
  TiffanyBlue = "#0ABAB5",
  WhiteSmoke = "#FAFAFA",
  Success = "#4BB543",
}
